import * as actions from "./material.action";
import inicialState from './material.state';

const recebimentoMaterialReducer = (state = inicialState, action) => {
    switch (action.type) {
        case actions.SHOW_FADE_CARREGANDO: {
            return {
                ...state,
                showCarregando: action.payload.showCarregando
            }
        }
        case actions.RECEBIMENTO_FINALIZADO: {
            return {
                ...state,
                recebimentoFinalizado: action.payload.recebimentoFinalizado
            }
        }
        case actions.PREENCHER_FILTRO:
            return {
                ...state,
                filtros: action.payload.filtros
            }
        case actions.PREENCHER_FAVORITOS:
            return {
                ...state,
                favoritos: action.payload.favoritos
            }
        case actions.PREENCHER_LISTAGEM:
            return {
                ...state,
                listagem: action.payload.listagem
            }
        case actions.ATUALIZAR_HEIGTH_FILTRO:
            return {
                ...state,
                heigth: action.payload.altura
            }
        case actions.EXIBIR_DETALHE_ITEM:
            return {
                ...state,
                detalhes: action.payload.detalhes,
                topografias: action.payload.topografias
            }
        case actions.ATUALIZAR_TOPOGRAFIAS:
            return {
                ...state,
                topografias: action.payload.topografias
            }
        case actions.ATUALIZAR_MEDICOS:
            return {
                ...state,
                medicos: action.payload.medicos
            }
        case actions.ATUALIZAR_DETALHES:
            return {
                ...state,
                detalhes: action.payload.detalhes
            }
        case actions.VISIBILIDADE_MODAL:
            return {
                ...state,
                visibilidadeModal: action.payload.visibilidade,
                itemClicadoNaListagem: action.payload.itemClicado
            }
        case actions.ATUALIZAR_TOTAIS_EXAMES:
            return {
                ...state,
                totalExamesAbertos: action.payload.totalExamesAbertos,
                totalExamesConcluidos: action.payload.totalExamesConcluidos
            }
        case actions.MUDAR_TAB_ATIVA:
            return {
                ...state,
                activeTab: action.payload.activeTab
            }
        case actions.PREENCHER_EXAMES_ABERTOS:
            return {
                ...state,
                examesAbertos: action.payload.exames
            }
        case actions.TIPO_VINCULO_SELECIONADO:
            return {
                ...state,
                tipoVinculoSelecionado: action.payload.tipo
            }
        case actions.ESTADO_MENU_LATERAL:
            return {
                ...state,
                collapsedMenu: action.payload.collapsedMenu
            }
        case actions.IMPRIMI_ETIQUETA_CONTROLE:
            return {
                ...state,
                imprimiEtiquetaControle: action.payload.imprimiEtiquetaControle
            }
        case actions.EXIBIR_CHECKLIST_RECEBIMENTO:
            return {
                ...state,
                exibirChecklistRecebimento: action.payload.exibirChecklistRecebimento
            }
        case actions.FATURAR_MEDICO_PADRAO:
            return {
                ...state,
                faturarMedicoPadrao: action.payload.faturarMedicoPadrao
            }
        case actions.MEDICO_EXECUTANTE_PADRAO:
            return {
                ...state,
                medicoExecutantePadrao: action.payload.medicoExecutantePadrao
            }
        case actions.EXIBIR_TELA_RECOLHIMENTO:
            return {
                ...state,
                exibirTelaRecolhimento: action.payload.exibirTelaRecolhimento
            }
        case actions.IMPRIMI_ETIQUETA_AGORA:
            return {
                ...state,
                imprimiEtiquetaAgora: action.payload.imprimiEtiquetaAgora
            }
        case actions.ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES:
            return {
                ...state,
                listagemMultiplosExames: action.payload.listagemMultiplosExames
            }        
        case actions.EXIBIR_MODAL_RECOLHIMENTO_LAUDO:
            return {
                ...state,
                modalRecolhimento: action.payload.modalRecolhimento
            }
        case actions.FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO:
            return {
                ...state,
                filtroLocalizacaoRegistroModalRecolhimento: action.payload.filtroLocalizacaoRegistroModalRecolhimento
            }
        case actions.ATUALIZAR_LAUDO_SELECIONADO:
            return {
                ...state,
                laudoSelecionado: action.payload.laudoSelecionado
            }
        case actions.EXISTE_NAOCONFORMIDADE_IMPEDITIVA:
            return {
                ...state,
                existeNaoConformidadeImpeditiva: action.payload.existeNaoConformidadeImpeditiva
            }
        case actions.ALTERAR_TOPOGRAFIA_SELECIONADA:
            return {
                ...state,
                topografiaselecionada: action.payload.topografiaselecionada
            }
        case actions.ALTERAR_MEDICO_MICROSCOPISTA_SELECIONADO:
            return {
                ...state,
                medicoMicroscopistaSelecionado: action.payload.medicoMicroscopistaSelecionado
            }
        case actions.ALTERAR_QUANTIDADE_FRASCOS:
            return {
                ...state,
                quantidadeFrascos: action.payload.quantidadeFrascos
            }
        default:
            return state;
    }
}

export default recebimentoMaterialReducer;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/material.reducer.js